import { Button } from "@/components/ui/button";
import { Film, Zap, Globe, Download, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-900 via-slate-800 to-slate-900">
      {/* Navbar */}
      <nav className="sticky top-0 z-50 border-b border-slate-700/50 bg-slate-900/80 backdrop-blur-md">
        <div className="max-w-6xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Film className="w-6 h-6 text-cyan-400" />
            <span className="text-lg font-bold text-white">FilmStudio AI</span>
          </div>
          <Link to="/studio">
            <Button className="bg-cyan-500 hover:bg-cyan-600">
              ابدأ الآن
            </Button>
          </Link>
        </div>
      </nav>

      {/* Hero */}
      <section className="max-w-6xl mx-auto px-4 py-20 text-center">
        <div className="space-y-6">
          <h1 className="text-5xl md:text-6xl font-bold text-white leading-tight">
            أنشئ أفلام مذهلة<br />
            <span className="bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
              بقوة الذكاء الاصطناعي
            </span>
          </h1>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            تحويل أفكارك إلى أفلام احترافية بجودة عالية مع صوت وترجمات بلغات متعددة
          </p>
          <div className="flex gap-4 justify-center pt-4">
            <Link to="/studio">
              <Button size="lg" className="bg-cyan-500 hover:bg-cyan-600">
                <Sparkles className="w-4 h-4 mr-2" />
                إنشاء فيلم جديد
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="max-w-6xl mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-8">
          {[
            {
              icon: <Zap className="w-8 h-8" />,
              title: "سريع جداً",
              desc: "إنتاج فيديوهات طويلة في دقائق",
            },
            {
              icon: <Globe className="w-8 h-8" />,
              title: "لغات متعددة",
              desc: "دعم العربية والإنجليزية وغيرها",
            },
            {
              icon: <Download className="w-8 h-8" />,
              title: "تحميل وعرض بدون إنترنت",
              desc: "احفظ أفلامك وعرضها في أي وقت",
            },
          ].map((feature, i) => (
            <div
              key={i}
              className="p-6 rounded-lg border border-slate-700 bg-slate-800/50 hover:bg-slate-800 transition"
            >
              <div className="text-cyan-400 mb-4">{feature.icon}</div>
              <h3 className="text-lg font-semibold text-white mb-2">
                {feature.title}
              </h3>
              <p className="text-slate-400">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
